import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportOds } from 'src/app/data/model/custom-report';

@Component({
  standalone: false,
  selector: 'app-readings-dialog',
  templateUrl: './readings-dialog.component.html',
  styleUrls: ['./readings-dialog.component.scss']
})
export class ReadingsDialogComponent implements OnInit {

  public get displayedColumns(): string[] {
    return ['seriale', 'numero_letture', 'is_panmobil', 'percentage']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReportOds[]
  ) { }


  ngOnInit(): void {
  }

}
